import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../../assets/Logo/logo.png'
import './Navbar.css'

const Navbar = () => {

    const menu = <>
        <li><Link to='/' className='font-bold'>Home</Link></li>
        <li><a href="#about" className='font-bold'>About</a></li>
        <li><a href='#services' className='font-bold'>Services</a></li>
        <li><a href="#portfolio" className='font-bold'>Portfolio</a></li>
        <li><a href="#contact" className='font-bold'>Contact</a></li>
        <li><Link to="/blog" className='font-bold'>Blog</Link></li>
        <li> <a href="Resume.pdf" download="Resume.pdf"><button className='resume-btn rounded'>Resume</button></a></li>
    </>
    return (
        <div>
            <div className="navbar bg-base-100 md:justify-around">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            {menu}
                        </ul>
                    </div>
                    <div>

                        <img src={Logo} className="h-20" alt="logo" />

                    </div>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal px-1">
                        {
                            menu
                        }
                    </ul>
                </div>



            </div>
        </div>
    );
};

export default Navbar;